import { usePaymentsCondition } from '@/core/domain/enterprise/PaymentCondition/PaymentCondition.hooks';
import {
  ListPaymentConditionsQuery,
  PaymentCondition,
} from '@/core/domain/enterprise/PaymentCondition/PaymentCondition.types';
import { useDebounce } from '@/hooks';
import { flatInfiniteData } from '@/utils/request/flatInfiniteData';
import { Select, SelectProps } from 'antd';
import { forwardRef, useEffect, useState } from 'react';

interface Props extends SelectProps {
  filter?: ListPaymentConditionsQuery;
  onSelectItem?: (data?: PaymentCondition) => void;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const PaymentConditionSelect = forwardRef<any, Props>(
  ({ filter, ...props }, ref) => {
    const [params, setParams] = useState<ListPaymentConditionsQuery>({
      name: '',
    });
    const nameDebounce = useDebounce(params?.name);
    const { data, isLoading } = usePaymentsCondition({
      ...params,
      name: nameDebounce,
    });

    const items = flatInfiniteData(data);

    useEffect(() => {
      setParams((state) => ({ ...state, ...filter }));
    }, [filter]);

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function handleChange(value: any, option: any) {
      const finded = items.find((item) => item.id === value);

      !!props.onSelectItem && props.onSelectItem(finded);

      !!props.onChange && props.onChange(value, option);
    }

    return (
      <Select
        allowClear
        loading={isLoading}
        style={{ width: '100%' }}
        {...props}
        onChange={handleChange}
        ref={ref}
        searchValue={params?.name}
        onSearch={(name) => setParams((state) => ({ ...state, name }))}
        options={items?.map((item) => ({
          value: item.id,
          label: item.name,
        }))}
      />
    );
  },
);

export default PaymentConditionSelect;
